/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MemberDataAsMember } from './MemberDataAsMember';
import {
    MemberDataAsMemberFromJSON,
    MemberDataAsMemberFromJSONTyped,
    MemberDataAsMemberToJSON,
} from './MemberDataAsMember';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';

/**
 * 
 * @export
 * @interface ListMemberData200Response
 */
export interface ListMemberData200Response {
    /**
     * 
     * @type {Array<MemberDataAsMember>}
     * @memberof ListMemberData200Response
     */
    data: Array<MemberDataAsMember>;
    /**
     * 
     * @type {Metadata}
     * @memberof ListMemberData200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the ListMemberData200Response interface.
 */
export function instanceOfListMemberData200Response(value: object): value is ListMemberData200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function ListMemberData200ResponseFromJSON(json: any): ListMemberData200Response {
    return ListMemberData200ResponseFromJSONTyped(json, false);
}

export function ListMemberData200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListMemberData200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MemberDataAsMemberFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function ListMemberData200ResponseToJSON(value?: ListMemberData200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(MemberDataAsMemberToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

